/** @format */

import {
	Component,
	EventEmitter,
	HostListener,
	Inject,
	Input,
	OnDestroy,
	OnInit,
	Output
} from '@angular/core';
import { Store } from '@ngrx/store';
import { selectAddToCartButtonText } from './+state/multi-add-to-cart-button.selector';
import { addToCartTriggered, selectSelectedBundlePruductsPrices } from '@pdp/data-access/state';
import { UtilityService, WINDOW } from '@shared/data-access/services';
import { CurrencyPipe, DOCUMENT, AsyncPipe } from '@angular/common';
import { combineLatest, Subject, takeUntil } from 'rxjs';
import { ATC_BUTTON_TEXTS } from '@pdp/add-to-cart/data-access';
import { HmfButtonComponent } from '@dsg-tech/homefield-angular';

@Component({
	selector: 'pdp-multi-add-to-cart-button',
	templateUrl: './multi-add-to-cart-button.component.html',
	styleUrl: './multi-add-to-cart-button.component.scss',
	providers: [CurrencyPipe],
	imports: [HmfButtonComponent, AsyncPipe]
})
export class MultiAddToCartButtonComponent implements OnDestroy, OnInit {
	// New properties
	addToCartButtonTextSelector$ = this.store.select(selectAddToCartButtonText);

	bundlePrice$ = this.store.select(selectSelectedBundlePruductsPrices);

	atcBtnTxt: string;

	/** Do we still need the below properties? **/

	showATCValidationMessage = false;

	isSecureLaunch = false;

	isInStoreOnly = false;
	addedToCart = false;

	storeSelectionReady = false;
	atcButtonTexts = ATC_BUTTON_TEXTS;

	@Input() allProductSkus;

	@Output()
	public showAddToBundleError = new EventEmitter<boolean>();

	private UNSUBSCRIBE$: Subject<void> = new Subject();

	constructor(
		public store: Store,
		public utilityService: UtilityService,
		@Inject(WINDOW) protected window: Window,
		@Inject(DOCUMENT) private document: Document,
		private currencyPipe: CurrencyPipe
	) {}

	ngOnDestroy(): void {
		this.UNSUBSCRIBE$.next();
		this.UNSUBSCRIBE$.complete();
	}

	ngOnInit() {
		combineLatest([this.addToCartButtonTextSelector$, this.bundlePrice$])
			.pipe(takeUntil(this.UNSUBSCRIBE$))
			.subscribe(([atcVal, bundleVal]: [{ addToCartButtonText: string }, number]) => {
				this.atcBtnTxt = atcVal.addToCartButtonText;

				if (bundleVal > 0 && atcVal.addToCartButtonText === ATC_BUTTON_TEXTS.atc) {
					this.atcBtnTxt = `${this.atcBtnTxt} | ${this.currencyPipe.transform(bundleVal)}`;
				}
			});

		if (window.headerFunctions?.storeSelection) {
			this.storeSelectionReady = true;
		}
	}

	addToCartButtonClicked(buttonType: string, buttonAction: string) {
		// if button action is SelectOptions scroll user to attributes
		if (buttonAction === 'SelectOptions') {
			this.showAddToBundleError.emit(true);
			this.utilityService.scrollToElement(
				this.document.getElementById('attributes-v2-container'),
				{
					behavior: 'smooth',
					block: 'center',
					inline: 'nearest'
				}
			);
		} else if (buttonType === ATC_BUTTON_TEXTS.noStoreSelected) {
			const storeSelectionValues = { skusArr: this.allProductSkus };
			if (this.window.headerFunctions?.storeSelection) {
				this.window.headerFunctions.storeSelection(storeSelectionValues);
			}
		} else if (buttonType === ATC_BUTTON_TEXTS.atc) {
			this.store.dispatch(addToCartTriggered());
		}
	}

	@HostListener('window:HeaderServices:StoreSelection:Ready', ['$event'])
	public onStoreSelectionReady(customEvent: CustomEvent): void {
		if (customEvent) {
			this.storeSelectionReady = true;
		}
	}
}
